import { render, staticRenderFns } from "./DefinitionsList.vue?vue&type=template&id=334cf020&scoped=true"
import script from "./DefinitionsList.vue?vue&type=script&lang=js"
export * from "./DefinitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334cf020",
  null
  
)

export default component.exports